import request from '@/request/request'
let baseURL = global.$config.api.apiUrl + '/emergency-server/'
// 出入库记录列表-分页
export function materialInoutList(data) {
  return request({
    baseURL,
    url: '/emergencyMaterialInout/list',
    method: 'post',
    data
  })
}
// 出入库记录新增
export function materialInoutSave(data) {
  return request({
    baseURL,
    url: '/emergencyMaterialInout/save',
    method: 'post',
    data
  })
}
// 出入库记录批量操作
export function materialInoutBatchSave(data) {
  return request({
    baseURL,
    url: '/emergencyMaterialInout/batchSave',
    method: 'post',
    data
  })
}
// 出入库记录修改
export function materialInoutUpdate(data) {
  return request({
    baseURL,
    url: '/emergencyMaterialInout/update',
    method: 'post',
    data: data
  })
}
// 出入库记录-详情
export function materialInoutDetail(query) {
  return request({
    baseURL,
    url: '/emergencyMaterialInout/detail',
    method: 'get',
    params: query
  })
}
// 出入库记录-删除
export function materialInoutRemove(data) {
  return request({
    baseURL,
    url: '/emergencyMaterialInout/remove',
    method: 'post',
    data: { ...data, isFormData:true }
  })
}